import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button, Tooltip } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';

const ToggleUsuario = () => {
  const record = useRecordContext();
  if (!record) return <div />;
  const [disabled, setDisabled] = useState(record.disabled);
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      company: localStorage.getItem('company'),
      authorization: `Bearer ${token}`,
    },
  };

  const handleToggle = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/toggleUser/${record.id}`, config)
      .then((res) => {
        setDisabled(res.data);
      });
  };

  return (
    <div>
      <Button style={{ color: 'black' }} onClick={handleToggle}>
        {disabled ? (
          <Tooltip title="Habilitar o Usuário">
            <VisibilityOffIcon />
          </Tooltip>
        ) : (
          <Tooltip title="Desabilitar o Usuário">
            <VisibilityIcon />
          </Tooltip>
        )}
      </Button>
    </div>
  );
};

export default ToggleUsuario;
